import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { zxFunctionFramework } from '@/mocks/zhongxian-commerce';

export default function FunctionFramework() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="产品功能框架"
          subtitle="以「中仙数智商贸」为总入口，向下延伸七大功能板块，覆盖市场经营、商户经营、食安溯源、消费激励、全渠道履约、县域生态与合规安全。"
        />

        <Reveal>
          <div className="mt-10 flex justify-center">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50">
              <i className="ri-apps-2-line"></i>
              <span className="font-heading font-bold text-sm md:text-base tracking-wide">中仙数智商贸</span>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {zxFunctionFramework.map((branch, idx) => (
            <Reveal key={branch.title} delay={Math.min(idx * 60, 360)}>
              <div className="h-full flex flex-col p-6 rounded-lg bg-background-100 border border-background-200 transition-colors hover:border-primary-300">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className={`${branch.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug">
                    {branch.title}
                  </h3>
                </div>
                <ul className="mt-4 space-y-2.5">
                  {branch.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-foreground-600 leading-relaxed">
                      <i className="ri-subtract-line mt-1.5 text-primary-500 shrink-0"></i>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}